import { SVG, Circle, Line, Path, Text, Shape, G } from "@svgdotjs/svg.js";
import "svg-pan-zoom";
import { Segment } from "./Segment";
import { Point } from "./Point";
import { IPoint } from "./Point";
import { Vector } from "./Vector";
import { SerializationHelper } from "./SerializationHelper";
import { Svg } from "@svgdotjs/svg.js";
import { UndoPoint } from "./UndoPoint";
import { SettingsManager } from "./SettingsManager";
import { isString, round, isNullOrWhitespace, GetOffsetPoint, GetAngleDegrees, GetArcPoints, GetAngle, DirectionFromAngle, GetLineAngle360, iOS, isMobile } from "./utils";
import { InToIn, InToInDbl, FtToFtDbl, FtToInDbl, FtToIn } from "./FeetIn";
import { HtmlManager } from "./HtmlManager";
import { TrimOptionsManager } from "./TrimOptionsManager";

export class TrimDesigner {
    #parentDiv: HTMLElement;
    #drawingDiv: HTMLElement;
    mySVG: Svg;
    svgElement: any;
    svgGroup: G;
    pt: any;
    tempCircle: Circle;
    me = this;
    constructor() { }

    #Points: Array<Point> = new Array<Point>();
    #tempPoint: Point = new Point(0, 0);

    svgCircles: Array<Circle> = new Array<Circle>();
    svgLines: Array<Line> = new Array<Line>();
    svgPaths: Array<Path> = new Array<Path>();
    linePoints: Array<LinePoint> = new Array<LinePoint>();
    svgInsideArc = new Array<Path>();
    svgLabels: { [key: string]: Text } = {};
    LabelOffsets: { [key: string]: Vector } = {};
    svgLenText = new Array<Text>();
    svgPaintLineShapes = new Array<Shape>();
    svgText = new Array<Text>();

    isDragging: boolean = false; // Dragging an element
    isPanning: boolean = false;
    isDrawing: boolean = true;
    pointBeforePan: IPoint = { x: 0, y: 0 };
    pointAfterPan: IPoint = { x: 0, y: 0 };
    panZoomInstance: SvgPanZoom.Instance;
    #Segments: Array<Segment> = new Array<Segment>();
    ScaleFactor = 96;

    #PaintLineOffset = 4;
    #MousePoint: Point;
    //#ReversePaintIndicator = false;

    #settings: SettingsManager;
    #htmlManager: HtmlManager;
    #trimOptionsManager: TrimOptionsManager;

    private _ReadOnly: boolean;
    public get ReadOnly(): boolean {
        return this._ReadOnly;
    }
    public set ReadOnly(v: boolean) {
        this._ReadOnly = v;
        this.stopDrawing();
        let inputs = document.getElementById("nctdDescriptionOptions")!.querySelectorAll("input,select");
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i] as HTMLInputElement;
            input.disabled = v;
        }
        inputs = document.getElementById("ncTrimOptions")!.querySelectorAll("input,select");
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i] as HTMLInputElement;
            input.disabled = v;
        }
        inputs = document.getElementById("ncDataTableDiv")!.querySelectorAll("input,select");
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i] as HTMLInputElement;
            input.disabled = v;
        }
    }

    private get ZoomScale(): number {
        if (this.panZoomInstance === undefined)
            return 1;
        return this.panZoomInstance.getZoom();
    }

    private get CircleSize(): number {
        if (this.panZoomInstance === undefined)
            return this.#settings.PointSize;
        let zoomLevel = this.panZoomInstance.getZoom();
        let ZoomScaleInverse = 1 / zoomLevel;
        if (zoomLevel > 1.6) {
            return this.#settings.PointSize;
        }
        else {
            return ZoomScaleInverse * this.#settings.PointSize * 1.4;
        }
    }

    private get FontSize(): number {
        if (this.panZoomInstance === undefined) {
            return 14;
        }

        let zoomLevel = this.panZoomInstance.getZoom();
        let ZoomScaleInverse = 1 / zoomLevel;
        if (zoomLevel > 1.6) {
            return 14;
        }
        else {
            return ZoomScaleInverse * (14 * 1.2);
        }
    }

    private get LineWidth(): number {
        if (this.panZoomInstance === undefined) {
            return 2;
        }
        let zoomLevel = this.panZoomInstance.getZoom();
        let ZoomScaleInverse = 1 / zoomLevel;
        if (zoomLevel > 1.6) {
            return 2;
        }
        else {
            return ZoomScaleInverse * (2 * 1.5);
        }
    }

    private get ZoomScaleInverse(): number {
        let zoomLevel = this.panZoomInstance.getZoom();
        return 1 / zoomLevel;
    }

    public get BlankWidth(): number {
        let lengthSum = 0;
        if (this.#Segments.length > 0) {
            for (let i = 0; i < this.#Segments.length; i++) {
                const segment = this.#Segments[i];
                lengthSum += segment.Length;
            }
        }
        return lengthSum;
    }


    public initTrimDesigner(parentElement: HTMLElement) {
        let me = this;
        this.#parentDiv = parentElement;
        this.#htmlManager = new HtmlManager(parentElement);
        this.#trimOptionsManager = new TrimOptionsManager();
        this.#trimOptionsManager.init();
        this.#drawingDiv = document.getElementById("drawing") as HTMLElement;

        this.#drawingDiv.oncontextmenu = function (event) {
            return false;
        };

        document.body.onkeydown = function (event) {
            if (event.key === 'z' && event.ctrlKey) { // undo
                if (event.target instanceof Element) {
                    if ((event.target).nodeName.toUpperCase() !== "INPUT") {
                        me.undo();
                    }
                }
            }
            if (event.key === 'y' && event.ctrlKey) { // redo
                if (event.target instanceof Element) {
                    if (event.target.nodeName.toUpperCase() !== "INPUT") {
                        me.redo();
                    }
                }

            }
            if (event.ctrlKey && event.shiftKey && event.key.toUpperCase() === 'F') {
                me.zoomToFit();
                event.stopPropagation();
                event.preventDefault();
            }

            event = event || window.event;
            var isEscape = false;
            if ("key" in event) {
                isEscape = (event.key === "Escape" || event.key === "Esc");
                if (isEscape) {
                    if (me.isDragging) {
                        me.isDragging = false;
                        me.isPanning = true;
                        me.addUndoPoint();
                        me.undo();
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    if (me.isDrawing) {
                        me.stopDrawing();
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            }
        }

        this.mySVG = SVG().addTo(this.#drawingDiv)
            .attr("id", "svg-container")
            .addClass("svg-container")
            .size("100%", "100%");
        this.svgElement = document.getElementById("svg-container");
        this.makeDraggable(this.svgElement);
        me.#settings = new SettingsManager(me.updateDrawingObjects.bind(me), me.zoomToFit.bind(me));

        (document.getElementById("nctdReversePaintSide") as HTMLInputElement).addEventListener("change", function () {
            me.updateDrawingObjects();
            me.addUndoPoint();
        });

        this.svgGroup = this.mySVG.group();
        // Create an SVGPoint for future math
        this.pt = this.svgElement.createSVGPoint();
        this.tempCircle = this.svgGroup.circle(5).fill("#2b7535").opacity(0.5).hide();
        this.initPanZoom();
        this.initSVG();

        this.initButtons();
    }

    private initPanZoom() {
        let me = this;

        me.panZoomInstance = svgPanZoom(me.svgElement, {
            panEnabled: true,
            controlIconsEnabled: false,
            zoomEnabled: true,
            dblClickZoomEnabled: false,
            mouseWheelZoomEnabled: true,
            preventMouseEventsDefault: true,
            zoomScaleSensitivity: 0.2,
            minZoom: 0.2,
            maxZoom: 2.8,
            fit: false,
            contain: false,
            center: false,
            refreshRate: "auto",
            //beforeZoom: function(){},
            onZoom: function (e) {
                // me.zooming is true when touch input sees user trying to zoom. 
                //We don't want to call update drawing objects here as it gets called twice on touch.
                // Only call update drawing objects when on a desktop with mouse.
                if (!me.#zooming) {
                    me.updateDrawingObjects();
                }
            },
            beforePan: function (oldPan, newPan) {
                // Save point before panning so we can check if the user actually panned on mouse up.
                if (!me.isPanning) {
                    me.pointBeforePan = oldPan;
                }
                me.pointAfterPan = newPan;
                me.isPanning = true;
            },
            // onPan: function (event) {
            //     pointAfterPan = event;
            // }
        });
    }
    #zooming = false;
    #startDist: number = 0;
    #centerPointOfZoom: Point = new Point(0, 0);

    private initSVG() {
        let me = this;

        me.mySVG.on("touchstart", function (event: TouchEvent) {
            let target = event.target as Element;
            let svgP = me.getMousePosition(event);
            me.#tempPoint = Point.newPoint(svgP);
            me.#MousePoint = Point.newPoint(svgP);

            if (event.touches.length === 2) {
                me.#zooming = true;

                me.#centerPointOfZoom = me.getCenterOfTouch(event);
                me.#startDist = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY
                );

                if (me.isDrawing) {
                    me.#zooming = true;
                    me.stopDrawing();
                }
                me.panZoomInstance.enablePan();
                return;
            }

            me.panZoomInstance.disablePan();
            if (target.tagName === "circle" || target.tagName === 'text') {
                me.panZoomInstance.disablePan();
            }
            else {
                me.startDrawing();
            }

            if (me.isDrawing) {
                if (me.#Points.length > 0) {
                    me.updateDrawingObjects();
                }
            }
        });

        me.mySVG.on("touchmove", function (event: TouchEvent) {
            if (me.#zooming) {
                let dist = Math.hypot(
                    event.touches[0].pageX - event.touches[1].pageX,
                    event.touches[0].pageY - event.touches[1].pageY
                );

                let dif = dist - me.#startDist;
                let z = me.panZoomInstance.getZoom();

                let centerOfTouch = me.getCenterOfTouch(event);
                me.panZoomInstance.zoomAtPoint(z + dif / 500, { x: centerOfTouch.x, y: centerOfTouch.y });
                //me.panZoomInstance.zoomAtPoint(z + dif / 500, { x: me.#centerPointOfZoom.x, y: me.#centerPointOfZoom.y });
                me.updateDrawingObjects();
                return;
            }
            if (me.isPanning) {
                return;
            }
            let svgP = me.getMousePosition(event);
            me.#tempPoint = Point.newPoint(svgP);
            me.#MousePoint = Point.newPoint(svgP);
            if (me.isDrawing) {
                me.updateDrawingObjects();
            }
        });

        me.mySVG.on("touchend", function (event: TouchEvent) {
            if (me.#zooming) {
                me.#zooming = false;
                return;
            }

            if (me.#tempPoint === undefined || me.#MousePoint === undefined) {
                let svgP = me.getMousePosition(event);
                me.#tempPoint = Point.newPoint(svgP);
                me.#MousePoint = Point.newPoint(svgP);
            }

            if (me.isDrawing) {
                if (me.isPanning) {
                    me.isPanning = false;
                    let x = Math.abs(me.pointBeforePan.x - me.pointAfterPan.x);
                    let y = Math.abs(me.pointBeforePan.y - me.pointAfterPan.y);
                    if (x < 3 || y < 3) {
                        me.addPoint();
                        me.stopDrawing();
                    }
                }
                else if (me.isDragging) {

                }
                else {
                    me.addPoint();
                    me.stopDrawing();
                }
            }

            me.isPanning = false;
            me.isDragging = false;
            me.panZoomInstance.enablePan();
        });

        me.mySVG.on("mousemove", function (event: MouseEvent) {
            let svgP = me.getMousePosition(event);
            me.#tempPoint = Point.newPoint(svgP);
            me.#MousePoint = Point.newPoint(svgP);
            if (me.isDrawing) {
                me.updateDrawingObjects();
            }
        });

        me.mySVG.on("mousedown", function (event: MouseEvent) {
            if (event.button == 1) {
                if (me.ReadOnly)
                    return;

                if (me.isDragging) {
                    me.isDragging = false;
                    me.isPanning = true;
                    me.addUndoPoint();
                    me.undo();
                    return;
                }
                if (me.svgCircles.length > 0) {
                    let lastCircle = me.svgCircles[me.svgCircles.length - 1];
                    me.deleteCircle(lastCircle);
                    me.updateDrawingObjects();
                    me.addUndoPoint();
                }
            }

            if (me.isDrawing) {
                if (event.button === 2) {
                    me.stopDrawing();
                }
            } else {
                if (event.button === 0) {
                    // isDrawing = true
                }
            }
        });

        me.mySVG.on("mouseup", function (event: MouseEvent) {

            if (event.button == 1) {
                return;
            }

            if (me.isDrawing) {
                if (me.isPanning) {
                    me.isPanning = false;
                    let x = Math.abs(me.pointBeforePan.x - me.pointAfterPan.x);
                    let y = Math.abs(me.pointBeforePan.y - me.pointAfterPan.y);
                    if (x < 3 || y < 3) {
                        me.addPoint();
                    }
                } else if (me.isDragging) {
                } else {
                    me.addPoint();
                }
            } else {
                if (!me.isPanning && !me.isDragging) {
                    let target = event.target as Element;
                    if (event.button === 0 && target.tagName !== "circle") {
                        me.startDrawing();
                    }
                }
            }
            me.isPanning = false;
            me.isDragging = false;
        });
    }

    getCenterOfTouch(e: TouchEvent): Point {
        let pan = this.panZoomInstance.getPan();
        let zoom = this.panZoomInstance.getZoom();
        let x = e.touches[0].pageX;
        let y = e.touches[0].pageY;


        this.pt.x = x - pan.x;
        this.pt.y = y - pan.y;

        let touch1 = this.pt.matrixTransform(
            this.svgElement.getScreenCTM().inverse()
        );

        touch1.x = touch1.x / zoom;
        touch1.y = touch1.y / zoom;

        x = e.touches[1].pageX;
        y = e.touches[1].pageY;

        this.pt.x = x - pan.x;
        this.pt.y = y - pan.y;

        let touch2 = this.pt.matrixTransform(
            this.svgElement.getScreenCTM().inverse()
        );

        touch2.x = touch2.x / zoom;
        touch2.y = touch2.y / zoom;

        let t1Point = Point.newPoint(touch1);
        let t2Point = Point.newPoint(touch2);

        let linePoint = new LinePoint(t1Point, t2Point);
        return linePoint.midwayPoint();
    }


    private _calculateCustomTrimPrice: CallableFunction;
    public get CalculateCustomTrimPrice(): CallableFunction {
        return this._calculateCustomTrimPrice;
    }
    public set CalculateCustomTrimPrice(v: CallableFunction) {
        this._calculateCustomTrimPrice = v;
        this.#trimOptionsManager.calculateCustomTrimPrice = this.CalculateCustomTrimPrice;
    }

    loadCoils(json) {
        this.#trimOptionsManager.LoadCoils(json);
    }

    addPoint() {
        let me = this;
        if (me.ReadOnly) return;
        if (me.#Points.length > 0) {
            let lastPoint = me.#Points[me.#Points.length - 1];
            if (lastPoint.equals(this.#tempPoint)) {
                return;
            }
        }
        me.#Points.push(me.#tempPoint.clone());
        me.updateDrawingObjects();
        me.addUndoPoint();
    }

    drawCircle(point: Point, idx: number) {
        let me = this;

        if (me.svgCircles[idx]) {
            me.svgCircles[idx].attr({ cx: point.x, cy: point.y });
            me.svgCircles[idx].data("idx", idx, true);
            me.svgCircles[idx].size(me.CircleSize);
        } else {
            let circle = me.svgGroup
                .circle(me.CircleSize)
                .fill("#123456")
                .opacity(0.5)
                .move(point.x, point.y);
            circle.attr({ cx: point.x, cy: point.y });
            circle.data("idx", idx, true);
            circle.dblclick(function (event: any) {
                if (!me.isDrawing) {
                    me.deleteCircle(this);
                    event.preventDefault();
                }
            });

            circle.mouseover(function () {
                if (!me.isDrawing) {
                    let circle: Circle = this;
                    circle.addClass("draggable");
                }
            });
            circle.mouseout(function () {
                if (!me.isDrawing) {
                    let circle: Circle = this;
                    circle.removeClass("draggable");
                }
            });

            let tappedTwice = false;
            circle.touchstart(function (event: TouchEvent) {
                if (!me.isDrawing) {
                    if (!tappedTwice) {
                        tappedTwice = true;
                        setTimeout(function () {
                            tappedTwice = false;
                        }, 400);
                        return false;
                    }
                    me.deleteCircle(this);
                    event.cancelBubble = true;
                    event.preventDefault();
                }
            });
            me.svgCircles.push(circle);
        }
    }

    deleteCircle(circle: Circle) {

        if (this.ReadOnly) return;

        let idx: number = circle.data("idx");
        circle.off();
        let n = this.svgCircles.indexOf(circle);
        this.svgCircles.splice(n, 1);
        circle.remove();
        this.#Points.splice(idx, 1);

        delete this.LabelOffsets["Angle" + (idx - 1)];
        delete this.LabelOffsets["Len" + (idx - 1)];

        this.updateDrawingObjects();
        this.addUndoPoint();
    }
    #updateDataGrid = true;
    updateDrawingObjects() {
        this.svgLines.forEach((line) => {
            line.remove();
        });

        this.svgPaths.forEach((c) => {
            c.remove();
        });
        this.svgInsideArc.forEach((c) => {
            c.remove();
        });
        this.svgPaintLineShapes.forEach((shape) => {
            shape.remove();
        });
        this.svgPaintLineShapes = new Array<Shape>();

        for (let key in this.svgLabels) {
            let label = this.svgLabels[key];
            label.off();
            label.remove();
            delete this.svgLabels[key];
        }

        this.svgLines.length = 0; // = new Array<Line>();

        this.svgPaths.length = 0; // = new Array<Path>();
        this.svgInsideArc.length = 0; // = new Array<Path>();

        if (this.#Points.length > 0) {
            this.drawTempObjects();
            this.drawLines();
            this.drawLineArcs();
            this.drawCircles();
            this.drawPaintLine();

            if (this.#updateDataGrid) {
                this.updateDataGrid();
            }
            this.drawAngleLabel();
            this.#trimOptionsManager.BlankWidthText = InToIn(this.BlankWidth);
        }
        if (this.isDrawing && this.#settings.ShowPoints) {
            this.tempCircle.show();
            this.tempCircle.attr({
                cx: this.#tempPoint.x,
                cy: this.#tempPoint.y,
                r: this.CircleSize / 2,
            });
            this.tempCircle.front();
        } else if (this.isDrawing && !this.#settings.ShowPoints) {
            this.tempCircle.hide();
        } else {
            this.tempCircle.hide();
            this.svgCircles.forEach((c) => {
                c.front();
            });
            for (let key in this.svgLabels) {
                let label = this.svgLabels[key];
                label.front();
            }

        }

        let highlightedInputs = document.getElementsByClassName("nctd-highlightInput");
        for (let i = 0; i < highlightedInputs.length; i++) {
            const element = highlightedInputs[i];
            element.classList.remove('nctd-highlightInput');
        }

        if (this.isDrawing) {
            let table = this.#htmlManager.getDataTable();
            let tbody = table.tBodies[0];
            let row = tbody.rows[tbody.rows.length - 2];

            if (row !== undefined) {
                let length = row.querySelector(".length") as HTMLInputElement;
                if (isMobile()) {
                    //Don't set the focus to the table as on a tablet it will open the on screen keyboard.
                    length.scrollIntoView();
                    length.classList.add('nctd-highlightInput');
                }
                else {
                    length.focus();
                    length?.select();
                }
            }
        }
    }

    #tempShapes = new Array<Shape>();
    drawTempObjects() {
        this.#tempShapes.forEach((shape) => shape.remove());
        this.#tempShapes.length = 0; //clear array

        if (this.#settings.Snap && this.isDrawing && this.#Points.length > 0) {
            //draw the cross hairs
            let closestX: number = this.#Points.reduce((x, y) =>
                Math.abs(x.x - this.#MousePoint.x) < Math.abs(y.x - this.#MousePoint.x)
                    ? x
                    : y
            ).x;
            let closestY: number = this.#Points.reduce((x, y) =>
                Math.abs(x.y - this.#MousePoint.y) < Math.abs(y.y - this.#MousePoint.y)
                    ? x
                    : y
            ).y;

            if (Math.abs(closestX - this.#MousePoint.x) <= this.#settings.SnapPrecision / this.ZoomScale) {
                //snap to closest horizontal point
                this.#MousePoint.x = closestX;
                this.#tempPoint.x = closestX;
                //drawingObjects.Add(new CrossHair() { Start = new Point(_MouseX, 0), End = new Point(_MouseX, 4000 * ZoomScaleInverse) });
                let line = this.svgGroup
                    .line(this.#tempPoint.x, -10000, this.#tempPoint.x, 10000)
                    .stroke({ color: "#2b7535", width: this.LineWidth / 3 });
                line.back();
                this.#tempShapes.push(line);
            }
            if (Math.abs(closestY - this.#MousePoint.y) <= this.#settings.SnapPrecision / this.ZoomScale) {
                //snap to closest horizontal point
                this.#MousePoint.y = closestY;
                this.#tempPoint.y = closestY;
                //drawingObjects.Add(new CrossHair() { Start = new Point(0, _MouseY), End = new Point(4000 * ZoomScaleInverse, _MouseY) });
                let line = this.svgGroup
                    .line(-100000, this.#tempPoint.y, 100000, this.#tempPoint.y)
                    .stroke({ color: "#2b7535", width: (this.LineWidth / 3) });
                line.back();
                this.#tempShapes.push(line);
            }
        }
    }

    drawCircles() {
        if (this.#settings.ProfileOnly || !this.#settings.ShowPoints) {
            this.svgCircles.forEach((c) => {
                c.off();
                c.remove();
            });
            this.svgCircles.length = 0;
            return;
        }
        //add points - draw the point in the middle of the bend radius
        let idx: number = 0;
        //drawingObjects.Insert(0, new Circle() { Size = CircleSize, Center = Points[0], PointIndex = idx });
        this.drawCircle(this.#Points[0], idx);
        idx++;

        for (let i = 0; i < this.svgPaths.length; i++) {
            const path = this.svgPaths[i];

            let length = path.length();
            let mid = path.pointAt(length / 2);
            let midPoint = new Point(mid.x, mid.y);
            this.drawCircle(midPoint, idx);
            idx++;
        }
        if (!this.isDrawing && this.#Points.length > 1)
            this.drawCircle(this.#Points[this.#Points.length - 1], idx);
    }

    drawLines() {
        this.svgLenText.forEach((element) => {
            element.remove();
        });
        this.svgLenText = new Array<Text>();
        let arcP1: Point;
        let arcP2: Point;
        let arcP2Last: Point = this.#Points[0];
        this.linePoints = new Array<LinePoint>();
        if (this.#Points.length > 0) {
            for (let i = 1; i < this.#Points.length; i++) {
                let p1: Point;

                if (i == this.#Points.length - 1) {
                    p1 = this.#tempPoint;
                } else {
                    p1 = GetOffsetPoint(this.#Points[i + 1], this.#Points[i], -30);
                }

                let p2 = GetOffsetPoint(arcP2Last, this.#Points[i], -30);
                let p3 = this.#Points[i];
                let angle = GetAngleDegrees(p1, p3, p2);
                if (angle == 0) {
                    angle = 0.01;
                }

                [arcP1, arcP2] = GetArcPoints(arcP2Last, this.#Points[i],
                    i == this.#Points.length - 1 ? this.#tempPoint : this.#Points[i + 1],
                    angle,
                    this.#settings.BendRadius
                );

                if (!this.isDrawing && i == this.#Points.length - 1) {
                    arcP1 = this.#Points[i];
                }

                let line = this.svgGroup
                    .line(arcP2Last.x, arcP2Last.y, arcP1.x, arcP1.y)
                    .stroke({ color: "black", width: this.LineWidth });
                this.svgLines.push(line);
                this.linePoints.push(new LinePoint(arcP2Last, arcP1));
                let len = Point.subtractPoint(arcP2Last, this.#Points[i]).length;
                let midPoint = GetOffsetPoint(arcP2Last, this.#Points[i], 0 - (len / 2));
                let last = arcP2Last.clone();
                let controlPoint = new Point(last.x - len / 2, last.y);
                let a = GetAngleDegrees(last, midPoint, controlPoint) * 2;
                if (a < 0) a += 90;
                else a -= 90;

                let textPoint = new Point(
                    // midPoint.x + Math.cos(a * (Math.PI / 180)) * (25 / this.ZoomScale),
                    // midPoint.y + Math.sin(a * (Math.PI / 180)) * (20 / this.ZoomScale)

                    midPoint.x + Math.cos(a * (Math.PI / 180)) * (25),
                    midPoint.y + Math.sin(a * (Math.PI / 180)) * (20)
                );
                let b =
                    this.#Points[i - 1].subtract(this.#Points[i]).length /
                    this.ScaleFactor; //.InToIn();
                this.drawLengthLabel(textPoint, b, i - 1);
                arcP2Last = arcP2.clone();
            }

            if (this.isDrawing) {
                if (isNaN(arcP2Last.x)) {
                    arcP2Last = this.#tempPoint.clone();
                }

                let line = this.svgGroup
                    .line(arcP2Last.x, arcP2Last.y, this.#tempPoint.x, this.#tempPoint.y)
                    .stroke({ color: "black", width: this.LineWidth });
                this.svgLines.push(line);
                this.linePoints.push(new LinePoint(arcP2Last, this.#tempPoint));

                let len = Point.subtractPoint(arcP2Last, this.#tempPoint).length / 2;
                let midPoint = GetOffsetPoint(arcP2Last, this.#tempPoint, 0 - len);
                let last = arcP2Last.clone();
                let controlPoint = new Point(last.x - len, last.y);
                let a = GetAngleDegrees(last, midPoint, controlPoint) * 2;
                if (a < 0) a += 90;
                else a -= 90;

                let textPoint = new Point(
                    midPoint.x + Math.cos(a * (Math.PI / 180)) * (25),
                    midPoint.y + Math.sin(a * (Math.PI / 180)) * (20)
                );
                let b =
                    this.#Points[this.#Points.length - 1].subtract(this.#tempPoint)
                        .length / this.ScaleFactor; //.InToIn();
                this.drawLengthLabel(textPoint, b, 9999);
            }
        }
    }

    drawLengthLabel(textPoint: Point, length: number, idx: number) {
        if (!this.#settings.ShowLengthLabels || this.#settings.ProfileOnly) {
            return;
        }
        if (length < this.#settings.LengthLabelLimit) {
            return;
        }
        let me = this;
        let offset: Vector = new Vector(0, 0);
        if ("Len" + idx in this.LabelOffsets) {
            offset = this.LabelOffsets["Len" + idx];
            textPoint.x = textPoint.x + (offset.x)
            textPoint.y = textPoint.y + (offset.y)
        }
        let len = InToIn(length.toString());
        let text = me.svgGroup.plain(len);
        text
            .move(textPoint.x - 10, textPoint.y - 8)
            .font({ fill: "black", family: "Inconsolata", size: me.FontSize });
        text.data("tag", "Len" + idx, true);

        text.mouseover(function () {
            if (!me.isDrawing) {
                let text: Text = this;
                text.font({ fill: "red" });
                text.addClass("draggable");
                let tag = text.data("tag");
                let input = document.getElementById(tag) as HTMLInputElement;
                input?.focus();
                input?.select();
            }
        });
        text.mouseout(function () {
            if (!me.isDrawing) {
                let text: Text = this;
                text.font({ fill: "black" });
                text.removeClass("draggable");
                let tag = text.data("tag");
                let input = document.getElementById(tag) as HTMLInputElement;
                input?.blur();
            }
        });
        text.dblclick(function () {
            if (me.ReadOnly) return;
            if (me.isDrawing) return;
            let text: Text = this;
            let tag: string = text.data("tag");
            let lineNumber = tag.substring(3);
            let lp: LinePoint = me.linePoints[lineNumber];
            let newPoint = lp.midwayPoint();
            me.#Points.splice(+lineNumber + 1, 0, newPoint);
            me.updateDrawingObjects();
            me.addUndoPoint();
        });
        let tappedTwice = false;
        text.touchstart(function (event: TouchEvent) {
            if (!me.isDrawing) {
                if (!tappedTwice) {
                    tappedTwice = true;
                    setTimeout(function () {
                        tappedTwice = false;
                    }, 800);
                    return false;
                }
                // add new point if the length label is double tapped.
                if (me.isDrawing) return;
                if (me.ReadOnly) return;

                let text: Text = this;
                let tag: string = text.data("tag");
                let lineNumber = tag.substring(3);
                let lp: LinePoint = me.linePoints[lineNumber];
                let newPoint = lp.midwayPoint();
                me.#Points.splice(+lineNumber + 1, 0, newPoint);
                me.updateDrawingObjects();

            }
        });

        let timer;
        let touchDuration = 800;
        let originalPoint: Point;
        let originalLabelPosition;
        let isLongPressed = false;
        text.touchstart(function (event: TouchEvent) {
            let text: Text = this;
            originalLabelPosition = new Point(text.x(), text.y());
            originalPoint = Point.newPoint(me.getMousePosition(event));
            if (!me.isDrawing) {
                if (!timer) {
                    timer = setTimeout(function () {
                        timer = null;

                        let tag = text.data("tag");
                        let input = document.getElementById(tag) as HTMLInputElement;
                        input?.focus();
                        input?.select();
                        isLongPressed = true;
                    }, touchDuration);
                }
            }
        });

        text.touchmove(function (event) {
            let p = Point.newPoint(me.getMousePosition(event));
            let v = p.subtract(originalPoint);
            if (v.x > 2 || v.y > 2) {
                //stops short touches from firing the event
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
            }
        });

        text.touchend(function (event) {
            //stops short touches from firing the event
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            if (isLongPressed) {
                this.move(originalLabelPosition.x, originalLabelPosition.y);
                isLongPressed = false;
                me.addUndoPoint();
            }
        });
        me.svgLabels["Len" + idx] = text;
    }

    drawAngleLabel() {
        let me = this;

        if (!me.#settings.ShowAngleLabels || this.#settings.ProfileOnly) {
            return;
        }

        for (let i = 0; i < me.svgPaths.length; i++) {
            const lineArc = me.svgPaths[i];
            const angleArc = me.svgInsideArc[i];
            let angle = 0;

            if (me.#Segments[i + 1] !== undefined) {
                angle = me.#Segments[i + 1].Angle;
            }

            let lineArcMidPoint = TrimDesigner.GetArcMidPoint(lineArc);
            let angleArcMidPoint = TrimDesigner.GetArcMidPoint(angleArc);

            let pointOffset = 20;// * (this.ZoomScaleInverse);//* (1 / this.panZoomInstance.getZoom());
            let textPoint = GetOffsetPoint(lineArcMidPoint, angleArcMidPoint, pointOffset);
            let offset: Vector = new Vector(0, 0);
            if ("Angle" + i in me.LabelOffsets) {
                offset = me.LabelOffsets["Angle" + i];
                textPoint.x = textPoint.x + (offset.x)
                textPoint.y = textPoint.y + (offset.y);
            }
            let xoffSet = 12; // * (this.ZoomScaleInverse * .5);
            let yoffSet = 8; //* (this.ZoomScaleInverse * .5);


            if (Math.abs(angle) > me.#settings.AngleLabelLimit && angle !== 0)
                continue;

            let text = me.svgGroup.plain(angle.toFixed(0).toString() + "°");
            text.move(textPoint.x - xoffSet, textPoint.y - yoffSet).font({ fill: "black", family: "Inconsolata", size: me.FontSize });
            text.data("tag", "Angle" + i, true);

            text.mouseover(function () {
                if (!me.isDrawing) {
                    let text: Text = this;
                    text.font({ fill: "red" });
                    text.addClass("draggable");
                    let tag = text.data("tag");
                    let input = document.getElementById(tag) as HTMLInputElement;
                    input?.focus();
                    input?.select();
                }
            });
            text.mouseout(function () {
                if (!me.isDrawing) {
                    let text: Text = this;
                    text.font({ fill: "black" });
                    text.removeClass("draggable");
                    let tag = text.data("tag");
                    let input = document.getElementById(tag) as HTMLInputElement;
                    input?.blur();
                }
            });

            let timer;
            let touchDuration = 800;
            let originalPoint: Point;
            let originalLabelPosition;
            let isLongPressed = false; // When the keyboard opens up when setting the focus on the input dataGrid it drags the label.
            text.touchstart(function (event: TouchEvent) {
                let text: Text = this;
                originalLabelPosition = new Point(text.x(), text.y());
                originalPoint = Point.newPoint(me.getMousePosition(event));
                if (!me.isDrawing) {
                    if (!timer) {
                        timer = setTimeout(function () {
                            timer = null;

                            let tag = text.data("tag");
                            let input = document.getElementById(tag) as HTMLInputElement;
                            input?.focus();
                            input?.select();
                            isLongPressed = true;
                        }, touchDuration);
                    }
                }
            });

            text.touchmove(function (event) {
                let p = Point.newPoint(me.getMousePosition(event));
                let v = p.subtract(originalPoint);
                if (v.x > 2 || v.y > 2) {
                    //stops short touches from firing the event
                    if (timer) {
                        clearTimeout(timer);
                        timer = null;
                    }
                }
            });

            text.touchend(function (event) {
                //stops short touches from firing the event
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
                if (isLongPressed) {
                    this.move(originalLabelPosition.x, originalLabelPosition.y);
                    isLongPressed = false;
                    me.addUndoPoint();
                }
            });
            me.svgLabels["Angle" + i] = text;
        }
    }

    drawArc(start: Point, end: Point, radius: number) {
        var d = ["M", start.x, start.y, "A", radius, radius, 0, 0, 1, end.x, end.y,].join(" ");
        let p = this.svgGroup.path(d).stroke({ color: "black", width: this.LineWidth }).fill("none");
        return p;
    }

    drawLineArcs() {
        let path: Path;
        if (this.#Points.length > 1) {
            if (this.isDrawing) {
                this.#Points.push(this.#tempPoint);
            }

            for (let i = 1; i < this.#Points.length - 1; i++) {
                //draw the angle
                let arcSize = 20;// ((30 / this.ZoomScale) * .5);
                //arcSize = Math.max(arcSize, 20);
                arcSize = Math.max(this.#settings.BendRadius, arcSize);
                let lastLine = this.linePoints[i - 1];
                let p1 = GetOffsetPoint(this.#Points[i + 1], this.#Points[i], 0 - arcSize);
                let p2 = GetOffsetPoint(lastLine.Start, this.#Points[i], 0 - arcSize);
                let p3 = this.#Points[i];
                let angle = GetAngleDegrees(p1, p3, p2);
                let arcP1: Point, arcP2: Point;
                if (angle == 0) angle = 0.01;
                [arcP1, arcP2] = GetArcPoints(lastLine.Start, this.#Points[i], this.#Points[i + 1], angle, this.#settings.BendRadius);
                arcP1 = lastLine.End;

                if (angle > 180) angle -= 360;
                let end: Point = GetOffsetPoint(this.#Points[i + 1], arcP2, 0 - p2.subtract(arcP1).length);
                let tan = Math.tan(90 - Math.abs(angle));
                if (Math.abs(angle) < 90) {
                    arcSize = arcSize * Math.tan((90 - Math.abs(angle)) / (180 / Math.PI)) + arcSize;
                }
                if (!isNaN(end.x) && !this.#settings.ProfileOnly) {
                    if (angle < 0) {
                        path = this.drawArc(end, p2, arcSize);
                    } else {
                        path = this.drawArc(p2, end, arcSize);
                    }
                    this.svgInsideArc.push(path);
                }

                if (!isNaN(arcP2.x)) {
                    if (angle <= 0) {
                        path = this.drawArc(arcP1, arcP2, this.#settings.BendRadius);
                    } else {
                        path = this.drawArc(arcP2, arcP1, this.#settings.BendRadius);
                    }
                    this.svgPaths.push(path);
                }
            }

            if (this.isDrawing)
                this.#Points.splice(-1, 1);
        }
    }

    drawPaintLine() {
        let lastPoint: Point = new Point(0, 0);
        let poffset = Math.min(this.panZoomInstance.getZoom(), 1.4);
        this.svgPaintLineShapes.forEach((shape) => {
            shape.remove();
        });
        this.svgPaintLineShapes = new Array<Shape>();

        if (!this.#settings.ShowPaintIndicator || this.#settings.ProfileOnly) {
            return;
        }

        for (let i = 0; i < this.linePoints.length; i++) {
            const line = this.linePoints[i];
            let offset: Vector = new Vector(0, 0);
            if (this.#trimOptionsManager.ReversePaintedSide) {
                offset = Vector.multiplyVectorScalar(DirectionFromAngle(GetAngle(line.Start, line.End) - 90), this.#PaintLineOffset / poffset);
            } else {
                offset = Vector.multiplyVectorScalar(DirectionFromAngle(GetAngle(line.Start, line.End) + 90), this.#PaintLineOffset / poffset);
            }
            //draw paint line
            let startPoint = line.Start.addVector(offset);
            let endPoint = line.End.addVector(offset);
            if (!isNaN(offset.x)) {
                let paintLine = this.svgGroup
                    .line(startPoint.x, startPoint.y, endPoint.x, endPoint.y)
                    .stroke({ color: '#FFD700', width: (this.LineWidth / 2), dasharray: '1,1' });
                this.svgPaintLineShapes.push(paintLine);

                if (i > 0 && (i < this.#Points.length - 1 || this.isDrawing)) {
                    //NOTE: Still have a bug where the paint line is drawn on the wrong side of the curve. - leave it for now
                    //draw the arc paint line
                    let a =
                        0 -
                        Vector.angleBetween(
                            Point.subtractPoint(this.#Points[i], this.#Points[i - 1]),
                            Point.subtractPoint(i < this.#Points.length - 1 ? this.#Points[i + 1] : this.#tempPoint, this.#Points[i]));
                    let IsInsideArc: boolean = 0 - Vector.angleBetween(Point.subtractPoint(this.#Points[i], this.#Points[i - 1]),
                        Point.subtractPoint(i < this.#Points.length - 1 ? this.#Points[i + 1] : this.#tempPoint, this.#Points[i])) > 0;
                    if (a == -180) IsInsideArc = true;

                    if (IsInsideArc) {
                        let arcRadius = this.#trimOptionsManager.ReversePaintedSide // this.#ReversePaintIndicator
                            ? this.#settings.BendRadius + this.#PaintLineOffset / this.ZoomScale
                            : this.#settings.BendRadius - this.#PaintLineOffset / this.ZoomScale;
                        if (arcRadius > 0) {
                            let s = line.Start.addVector(offset);
                            let d = ["M", lastPoint.x, lastPoint.y, "A", arcRadius, arcRadius, 0, 0, 0, s.x, s.y,].join(" ");
                            let p = this.svgGroup.path(d).stroke({ color: "#FFD700", width: (this.LineWidth / 2), dasharray: '1,1' }).fill("none");
                            this.svgPaintLineShapes.push(p);
                            // drawingObjects.Insert(0, new ArcPaintLine() { End = lastPoint, Start = line.Start + offset, Size = arcRadius });
                        }
                    } else {
                        let arcRadius = this.#trimOptionsManager.ReversePaintedSide //this.#ReversePaintIndicator
                            ? this.#settings.BendRadius - this.#PaintLineOffset / poffset
                            : this.#settings.BendRadius + this.#PaintLineOffset / poffset;
                        if (arcRadius > 0) {
                            // drawingObjects.Insert(0, new ArcPaintLine() { Start = lastPoint, End = line.Start + offset, Size = arcRadius });
                            let s = line.Start.addVector(offset);
                            let d = ["M", lastPoint.x, lastPoint.y, "A", arcRadius, arcRadius, 0, 0, 1, s.x, s.y,].join(" ");
                            let p = this.svgGroup.path(d).stroke({ color: "#FFD700", width: (this.LineWidth / 2), dasharray: "1,1" }).fill("none");
                            this.svgPaintLineShapes.push(p);
                        }
                    }
                }
                lastPoint = line.End.addVector(offset);
            }
        }
    }

    updateDataGrid() {
        let me = this;
        let table = this.#htmlManager.getDataTable();
        let tbody = table.tBodies[0];
        let cnt = 0;
        let lastAngle = 0.0;
        let segmentIndex = 1;
        let template = document.getElementById("rowTemplate") as HTMLTemplateElement;

        if (me.isDrawing) {
            cnt = me.#Points.length;
        } else {
            cnt = me.#Points.length - 1;
        }

        me.#Segments = new Array<Segment>();
        for (let i = 0; i < cnt; i++) {
            let p1 = me.#Points[i];
            let p2 = i === me.#Points.length - 1 ? me.#tempPoint : me.#Points[i + 1];
            let len = Point.subtractPoint(p1, p2).length / me.ScaleFactor;
            let lineAngle = 0 - (180 - GetLineAngle360(p1, p2));
            let angle = lineAngle - lastAngle;
            if (angle > 180) angle = 0 - (360 - angle);
            if (angle < -180) angle = 360 + angle;
            lastAngle = lineAngle;
            let seg = new Segment(len, angle);
            seg.segmentIndex = segmentIndex;
            me.#Segments.push(seg);
            segmentIndex++;
        }

        for (let i = 0; i < me.#Segments.length + 1; i++) {
            let seg = me.#Segments[i];
            if (seg === undefined) {
                seg = new Segment(0, 0);
                seg.segmentIndex = 0;
            }
            let length: HTMLInputElement;
            let angle: HTMLInputElement;
            let row: HTMLTableRowElement = tbody.rows[i];
            if (row === undefined) {
                row = tbody.insertRow();
                let rowClone = document.importNode(template.content, true);
                row.appendChild(rowClone);
                length = row.querySelector(".length") as HTMLInputElement;
                length.addEventListener("change", () => me.dataTableChanged());
                angle = row.querySelector(".angle") as HTMLInputElement;
                angle.addEventListener("change", () => this.dataTableChanged());

                let btn = row.querySelector('.btnremovePoint') as HTMLButtonElement;
                btn.onclick = function () {
                    if (me.ReadOnly) return;
                    let tr = btn.closest('tr');
                    let l = tr?.querySelector('.length') as HTMLInputElement;
                    let a = tr?.querySelector('.angle') as HTMLInputElement;

                    delete me.LabelOffsets[a.id];
                    delete me.LabelOffsets[l.id];
                    tr?.remove();
                    me.dataTableChanged();
                }

            } else {
                length = row.querySelector(".length") as HTMLInputElement;
                angle = row.querySelector(".angle") as HTMLInputElement;
            }

            row.id = seg.segmentIndex === 0 ? "NewRow" : seg.segmentIndex.toString();
            let segmentTD = row.querySelector(".segmentIdx") as HTMLTableDataCellElement;
            segmentTD.textContent = seg.segmentIndex == 0 ? "" : seg.segmentIndex.toString();

            length.id = "Len" + (seg.segmentIndex - 1);
            length.value = seg.segmentIndex == 0 ? "" : InToIn(seg.Length.toString());

            angle.id = "Angle" + (seg.segmentIndex - 2);
            angle.value = seg.segmentIndex == 0 ? "" : round(seg.Angle, 0).toString() + "°";
        }

        if (tbody.rows.length > this.#Segments.length) {
            const emptyRow = tbody.rows[this.#Segments.length];
            emptyRow.id = "NewRow";
            let length = emptyRow.querySelector(".length") as HTMLInputElement;
            let angle = emptyRow.querySelector(".angle") as HTMLInputElement;
        }
        for (let i = this.#Segments.length + 1; i < tbody.rows.length; i++) {
            const element = tbody.rows[i];
            element.remove();
        }
    }

    clearDatagrid() {
        let me = this;
        let table = this.#htmlManager.getDataTable();
        let tbody = table.tBodies[0];
        let template = document.getElementById("rowTemplate") as HTMLTemplateElement;

        while (tbody.rows.length) {
            tbody.rows[0].remove();
        }
        let row = tbody.insertRow();
        let rowClone = document.importNode(template.content, true);
        row.appendChild(rowClone);
        let length = row.querySelector(".length") as HTMLInputElement;
        length.addEventListener("change", () => me.dataTableChanged());
        let angle = row.querySelector(".angle") as HTMLInputElement;
        angle.addEventListener("change", () => this.dataTableChanged());
    }

    clearTrim() {
        this.#Segments = new Array<Segment>();
        this.#Points = new Array<Point>();
        this.LabelOffsets = {};
        this.#UndoStack.length = 0;
        this.#RedoStack.length = 0;
        this.#trimOptionsManager.ReversePaintedSide = false; // this.#ReversePaintIndicator = false;
        this.svgCircles.forEach((c) => { c.off(); c.remove(); });
        this.svgCircles.length = 0;
        this.svgLines.forEach((line) => { line.remove(); });
        this.svgLines.length = 0;
        this.svgPaths.forEach((c) => { c.remove(); });
        this.svgPaths.length = 0;
        this.svgInsideArc.forEach((c) => { c.remove(); });
        this.svgInsideArc.length = 0;
        this.svgPaintLineShapes.forEach((c) => { c.remove(); });
        this.svgPaintLineShapes.length = 0;
        this.svgPaintLineShapes.forEach((c) => { c.remove(); });
        this.svgPaintLineShapes.length = 0;

        for (let key in this.svgLabels) {
            let label = this.svgLabels[key];
            label.off();
            label.remove();
            delete this.svgLabels[key];
        }
        this.isDrawing = false;
        this.clearDatagrid();
    }

    newTrim(qbItem) {
        let itemObject
        this.clearTrim();
        if (isString(qbItem)) {
            itemObject = JSON.parse(qbItem);
        } else {
            itemObject = qbItem;
        }

        let o = { name: qbItem.description, colorId: qbItem.colorId, coilId: qbItem.coilId, length: qbItem.length, trimId: qbItem.trimId };
        this.#trimOptionsManager.loadCustomTrimOptions(o);
    }

    changeTrimItem(trimJson) {
        let itemObject
        this.clearTrim();
        if (isString(trimJson)) {
            itemObject = JSON.parse(trimJson);
        } else {
            itemObject = trimJson;
        }

        for (let i = 0; i < itemObject.Segments.length; i++) {
            const segment = itemObject.Segments[i];
            this.#Segments.push(new Segment(segment.Length, segment.Angle));
        }

        for (let key in itemObject.LabelOffsets) {
            if (itemObject.LabelOffsets.hasOwnProperty(key)) {
                let offset = itemObject.LabelOffsets[key]; //as string;

                if (isString(offset)) {
                    if (offset.includes(",")) {
                        let values = offset.split(",");
                        this.LabelOffsets[key] = new Vector(+values[0], +values[1]);
                    }
                } else {
                    this.LabelOffsets[key] = new Vector(offset.x, offset.y);
                }
            }
        }

        this.#trimOptionsManager.loadCustomTrimOptions(itemObject);
        return this.getJson();
    }

    loadCustomTrim(trimJsonData) {
        let trimObject;
        this.clearTrim();
        if (isString(trimJsonData)) {
            trimObject = JSON.parse(trimJsonData);
        } else {
            trimObject = trimJsonData
        }

        for (let i = 0; i < trimObject.Segments.length; i++) {
            const segment = trimObject.Segments[i];
            this.#Segments.push(new Segment(segment.Length, segment.Angle));
        }

        for (let key in trimObject.LabelOffsets) {
            if (trimObject.LabelOffsets.hasOwnProperty(key)) {
                let offset = trimObject.LabelOffsets[key]; //as string;

                if (isString(offset)) {
                    if (offset.includes(",")) {
                        let values = offset.split(",");
                        this.LabelOffsets[key] = new Vector(+values[0], +values[1]);
                    }
                } else {
                    this.LabelOffsets[key] = new Vector(offset.x, offset.y);
                }
            }
        }

        this.#trimOptionsManager.loadCustomTrimOptions(trimObject);

        this.loadSegments();
        this.addUndoPoint();
        // Had occasional error when calling zoomToFit without waiting.
        setTimeout(() => {
            this.zoomToFit();
        }, 100);
    }

    calculatePrice() {
        this.#trimOptionsManager.calculatePrice();
    }


    #zoomToFitCallCount = 0;
    zoomToFit() {
        let me = this;
        let edgeOffset = 100.0;
        let dhw = window.getComputedStyle(me.#drawingDiv);
        let i = 1;
        if (dhw.width.includes('calc')) {
            setTimeout(() => {
                if (me.#zoomToFitCallCount == 100) return;
                me.zoomToFit();
                me.#zoomToFitCallCount++;
            }, 10);
            return;
        }

        let targetWidth = parseInt((dhw.width.replace('px', ''))) - (edgeOffset * 1);
        let targetHeight = parseInt((dhw.height.replace('px', ''))) - (edgeOffset * 1);
        let viewBox = this.svgGroup.bbox();
        let newScale = Math.min(targetWidth / viewBox.width, targetHeight / viewBox.height);
        this.panZoomInstance.zoom(newScale);

        let zoom = this.panZoomInstance.getZoom();
        targetWidth = (+dhw.width.replace('px', ''));
        targetHeight = (+dhw.height.replace('px', ''));

        let offsetX = (targetWidth - (viewBox.width + viewBox.x * 2) * zoom) * 0.5;
        let offsetY = (targetHeight - (viewBox.height + viewBox.y * 2) * zoom) * 0.5;

        this.panZoomInstance.pan({ x: offsetX, y: offsetY });
        this.isPanning = false; // Need this as before pan event fires and sets isPanning to true.

        me.#zoomToFitCallCount = 0;

    }

    getDescription() {
        return this.#trimOptionsManager.getDescription();
    }

    getJson() {
        let labelOffsetStrings: { [key: string]: string } = {};
        for (let key in this.LabelOffsets) {
            let value = this.LabelOffsets[key];
            let xy = value.x.toString() + "," + value.y.toString();
            labelOffsetStrings[key] = xy;
        }

        let name = this.#trimOptionsManager.Name;
        let coilId = +this.#trimOptionsManager.SelectedCoil;
        let colorId = Number(this.#trimOptionsManager.SelectedColor);
        let coilName = this.#trimOptionsManager.CoilName;
        let colorName = this.#trimOptionsManager.ColorName;
        let includeLength = this.#trimOptionsManager.DescriptionIncludeLength;
        let includeCoil = this.#trimOptionsManager.DescriptionIncludeCoil;
        let includeColor = this.#trimOptionsManager.DescriptionIncludeColor;

        if (this.#Segments.length > 0) {
            let o = {
                Name: name, CoilId: coilId, ColorId: colorId, CoilName: coilName, ColorName: colorName, Length: this.#trimOptionsManager.Length,
                DescriptionIncludeLength: includeLength, DescriptionIncludeCoil: includeCoil, DescriptionIncludeColor: includeColor,
                Segments: this.#Segments, LabelOffsets: labelOffsetStrings, ReversePaintedSide: this.#trimOptionsManager.ReversePaintedSide // this.#ReversePaintIndicator
            };
            let strJson = JSON.stringify(o);
            return strJson;
        }
        else {
            return null;
        }
    }

    dataTableChanged() {
        let table = this.#htmlManager.getDataTable();
        let tbody = table.tBodies[0];

        this.#Segments = new Array<Segment>();

        for (let i = 0; i < tbody.rows.length; i++) {
            const tr = tbody.rows[i];
            let lengthInput = tr.querySelector(".length") as HTMLInputElement;
            let angleInput = tr.querySelector(".angle") as HTMLInputElement;

            let length = InToInDbl(lengthInput.value);
            let angle = this.getAngleFromString(angleInput.value);

            if (!((isNullOrWhitespace(lengthInput.value) || length == 0) && isNullOrWhitespace(angleInput.value))) {
                let nseg = new Segment(length, angle);
                this.#Segments.push(nseg);
            }

            if (!isNullOrWhitespace(lengthInput.value)) {
                lengthInput.value = InToIn(length.toString());
                angleInput.value = round(angle, 0).toString() + "°";
            }

            // If the length is zero it zeros the remaining length in the list when updating the grid.
            if (length === 0) {
                this.#updateDataGrid = false;
            }
        }

        this.loadSegments();
        this.#updateDataGrid = true;
        this.me.addUndoPoint();
    }

    getAngleFromString(text: string) {
        let Angle: number = 0;
        text = text.toLowerCase();
        if (text.endsWith("p") || text.endsWith("*")) {
            let pitch: number = +text
                .replace("p", "")
                .replace("-", "")
                .replace("*", "");
            let degrees: number = Math.atan(pitch / 12.0) * (180 / Math.PI);
            Angle = text.startsWith("-") ? 0 - degrees : degrees;
        } else if (text.endsWith("p++") || text.endsWith("*++")) {
            let pitch: number = +text
                .replace("p", "")
                .replace("++", "")
                .replace("*", "");
            let degrees: number = 180 - Math.atan(pitch / 12.0) * (180 / Math.PI);
            Angle = text.startsWith("-") ? 0 - degrees : degrees;
        } else if (text.endsWith("p-") || text.endsWith("*-")) {
            let pitch: number = +text
                .replace("p", "")
                .replace("-", "")
                .replace("*", "");
            let degrees: number = 90 - Math.atan(pitch / 12.0) * (180 / Math.PI);
            Angle = text.startsWith("-") ? 0 - degrees : degrees;
        } else if (text.endsWith("p+") || text.endsWith("*+")) {
            let pitch: number = +text
                .replace("p", "")
                .replace("+", "")
                .replace("*", "");
            let degrees: number = Math.atan(pitch / 12.0) * (180 / Math.PI) + 90;
            Angle = text.startsWith("-") ? 0 - degrees : degrees;
        } else {
            Angle = +text.replace("°", "");
            if (isNaN(Angle)) {
                Angle = 0;
            }
        }

        if (Angle < -179.9) Angle = -179.9;
        if (Angle > 179.9) Angle = 179.9;

        return Angle;
    }

    loadSegments() {
        this.svgCircles.forEach((c) => {
            c.off();
            c.remove();
        });
        this.svgCircles.length = 0;
        //let points: Array<Point> = new Array<Point>();
        // Set isDrawing to false when loading existing design.
        // this.isDrawing = false;
        if (this.#Points.length > 0) {
            let p = this.#Points[0].clone();
            this.#Points.length = 0;
            this.#Points.push(p);
        } else {
            this.#Points.push(new Point(50, 50));
        }

        let lastAngle: number = 0;
        for (let i = 0; i < this.#Segments.length; i++) {
            let angle: number = lastAngle + this.#Segments[i].Angle;
            let lastPoint: Point = this.#Points[this.#Points.length - 1];

            let d: Vector = Vector.directionFromAngle(angle);
            let len: number = this.#Segments[i].Length;
            let s: number = len * 96; // 96 is the scale factor.
            let v = Vector.multiplyVectorScalar(d, s);
            let newP = new Point(lastPoint.x, lastPoint.y);

            let point: Point = newP.addVector(v);

            this.#Points.push(point);
            lastAngle = angle;
        }
        this.updateDrawingObjects();
    }


    static CreateThumbNailSVG(trimJsonData) {
        let trimObject;
        let segments = new Array<Segment>();
        let points = new Array<Point>();
        let lastAngle: number = 0;
        let size = 100;

        if (typeof trimJsonData === "string") {
            trimObject = JSON.parse(trimJsonData);
        } else {
            trimJsonData = trimObject;
        }
        for (let i = 0; i < trimObject.Segments.length; i++) {
            const segment = trimObject.Segments[i];
            segments.push(new Segment(segment.Length, segment.Angle));
        }

        points.push(new Point(1, 1));
        // let lastAngle: number = 0;
        for (let i = 0; i < segments.length; i++) {
            let angle: number = lastAngle + segments[i].Angle;
            let lastPoint: Point = points[points.length - 1];
            let d: Vector = Vector.directionFromAngle(angle);
            let len: number = segments[i].Length;
            let s: number = len * 96; // 96 is the scale factor.
            let v = Vector.multiplyVectorScalar(d, s);
            let newP = new Point(lastPoint.x, lastPoint.y);
            let point: Point = newP.addVector(v);
            points.push(point);
            lastAngle = angle;
        }

        let arcP1: Point;
        let arcP2: Point;
        let arcP2Last: Point = points[0];
        let linePoints = new Array<LinePoint>();
        let bendRadius = 4.5
        let tempPoint = points[points.length - 1];

        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // svg.setAttributeNS(null, 'width', '100%');
        // svg.setAttributeNS(null, 'height', '100%');

        let max = points[0].clone(), min = points[0].clone();
        points.forEach((point) => {
            min.y = Math.min(min.y, (point.y));
            max.x = Math.max(max.x, point.x);
            max.y = Math.max(max.y, point.y);
            min.x = Math.min(min.x, point.x);
        });
        let viewBoxX = max.x + Math.abs(min.x);
        let viewBoxY = max.y + Math.abs(min.y);
        let v = Point.subtractPoint(max, min);
        // let stroke = Math.ceil((v.length - 300) / 100) * 1.7;
        let stroke = Math.max(viewBoxX, viewBoxY) / 45; // 180 / 4
        stroke = Math.max(stroke, 4);
        svg.setAttribute("viewBox", `${0} ${0} ${viewBoxX + 30} ${viewBoxY + 20}`);
        svg.classList.add('nctdThumbnail');
        let g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        let tx = Math.abs(min.x) + 10;
        let ty = Math.abs(min.y) + 10
        let gs = `translate(${tx}px, ${ty}px)`;
        g.style.transform = gs;
        svg.appendChild(g);

        tempPoint = new Point(0, 0);
        if (points.length > 0) {
            for (let i = 1; i < points.length; i++) {
                let p1: Point;

                if (i == points.length - 1) {
                    p1 = tempPoint
                } else {
                    p1 = GetOffsetPoint(points[i + 1], points[i], -30);
                }

                let p2 = GetOffsetPoint(arcP2Last, points[i], -30);
                let p3 = points[i];
                let angle = GetAngleDegrees(p1, p3, p2);
                if (angle == 0) {
                    angle = 0.01;
                }
                [arcP1, arcP2] = GetArcPoints(arcP2Last, points[i], i == points.length - 1 ? tempPoint : points[i + 1], angle, bendRadius);
                if (i == points.length - 1) {
                    arcP1 = points[i];
                }
                let line = createLine(arcP2Last, arcP1, stroke);
                g.appendChild(line);
                linePoints.push(new LinePoint(arcP2Last, arcP1));
                arcP2Last = arcP2.clone();
            }
        }

        if (points.length > 1) {
            for (let i = 1; i < points.length - 1; i++) {
                //draw the angle
                let arcSize = 30; // this.ZoomScale;
                arcSize = Math.max(bendRadius, arcSize);
                let lastLine = linePoints[i - 1];
                let p1 = GetOffsetPoint(points[i + 1], points[i], 0 - arcSize);
                let p2 = GetOffsetPoint(lastLine.Start, points[i], 0 - arcSize);
                let p3 = points[i];
                let angle = GetAngleDegrees(p1, p3, p2);
                let arcP1: Point, arcP2: Point;
                if (angle == 0) angle = 0.01;
                [arcP1, arcP2] = GetArcPoints(lastLine.Start, points[i], points[i + 1], angle, bendRadius);
                arcP1 = lastLine.End;

                if (angle > 180) angle -= 360;
                let end: Point = GetOffsetPoint(points[i + 1], arcP2, 0 - p2.subtract(arcP1).length);
                let tan = Math.tan(90 - Math.abs(angle));
                if (Math.abs(angle) < 90) {
                    arcSize = arcSize * Math.tan((90 - Math.abs(angle)) / (180 / Math.PI)) + arcSize;
                }
                let path: SVGPathElement;
                if (!isNaN(arcP2.x)) {
                    if (angle <= 0) {
                        path = drawArc(arcP1, arcP2, bendRadius, stroke);
                    } else {
                        path = drawArc(arcP2, arcP1, bendRadius, stroke);
                    }
                    g.appendChild(path);
                }
            }
        }

        return svg

        function createLine(p1: Point, p2: Point, strokeWidth: number = 6) {
            let newLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            // // newLine.setAttribute('id', 'line2');
            newLine.setAttribute('x1', p1.x.toString());
            newLine.setAttribute('y1', p1.y.toString());
            newLine.setAttribute('x2', p2.x.toString());
            newLine.setAttribute('y2', p2.y.toString());
            newLine.setAttribute("stroke", "black");
            newLine.setAttribute("stroke-width", strokeWidth.toString());
            return newLine
        }

        function drawArc(start: Point, end: Point, radius: number, strokeWidth: number = 6) {
            var d = ["M", start.x, start.y, "A", radius, radius, 0, 0, 1, end.x, end.y,].join(" ");

            let path = document.createElementNS("http://www.w3.org/2000/svg", 'path');
            path.setAttribute('d', d);
            path.setAttribute('fill', 'none');
            path.setAttribute("stroke", "black");
            path.setAttribute("stroke-width", strokeWidth.toString());
            return path;
        }
    }

    getMousePosition(e: any) {
        let pan = this.panZoomInstance.getPan();

        let x = 0;
        let y = 0;

        if (
            e.type == "touchstart" ||
            e.type == "touchmove" ||
            e.type == "touchend" ||
            e.type == "touchcancel"
        ) {
            var evt = typeof e.originalEvent === "undefined" ? e : e.originalEvent;
            var touch = evt.touches[0] || evt.changedTouches[0];
            x = touch.clientX;
            y = touch.clientY;
        } else if (
            e.type == "mousedown" ||
            e.type == "mouseup" ||
            e.type == "mousemove" ||
            e.type == "mouseover" ||
            e.type == "mouseout" ||
            e.type == "mouseenter" ||
            e.type == "mouseleave"
        ) {
            x = e.clientX;
            y = e.clientY;
        }

        this.pt.x = x - pan.x;
        this.pt.y = y - pan.y;

        let coord = this.pt.matrixTransform(
            this.svgElement.getScreenCTM().inverse()
        );
        let p = this.panZoomInstance.getZoom();
        coord.x = coord.x / p;
        coord.y = coord.y / p;
        return coord;
    }

    makeDraggable(element: HTMLElement) {
        let me = this;
        let svg: any = element;

        svg.addEventListener("mousedown", startDrag);
        svg.addEventListener("mousemove", drag);
        svg.addEventListener("mouseup", endDrag);
        svg.addEventListener("mouseleave", endDrag);
        svg.addEventListener("touchstart", startDrag);
        svg.addEventListener("touchmove", drag);
        svg.addEventListener("touchend", endDrag);
        svg.addEventListener("touchleave", endDrag);
        svg.addEventListener("touchcancel", endDrag);

        var selectedElement: any,
            offset: any,
            transform: any,
            bbox: any,
            minX: any,
            maxX: any,
            minY: any,
            maxY: any,
            confined: any;

        var boundaryX1 = 10.5;
        var boundaryX2 = 30;
        var boundaryY1 = 2.2;
        var boundaryY2 = 19.2;
        let idx: number = 0; // idx of object for now its a circle.
        let tag: string = "";
        let oldPoint = new Point(0, 0);
        let mouseOffset: Vector = new Vector(0, 0);
        function startDrag(evt: any) {
            if (me.isDrawing || me.ReadOnly) return;

            let elementTagName = evt.target.localName;
            if (!(evt.target.classList.contains("draggable") || elementTagName === "circle" || elementTagName === "text")) return;

            if (
                evt.target.classList.contains("draggable") || evt.target.localName === "circle" ||
                evt.target.localName === "text"
                // need the circle when on touch.
            ) {
                idx = evt.target.dataset.idx;
                tag = evt.target.dataset.tag;
                me.isDragging = true;
                me.panZoomInstance.disablePan();
                selectedElement = evt.target;
                if (selectedElement.nodeName === "text") {
                    let label = me.svgLabels[tag];
                    oldPoint = new Point(label.x(), label.y());
                } else {
                    // Must be a circle.
                    // If there is only one circle(Point). I need to set idx to zero. Not sure...
                    if (me.#Points.length == 1) {
                        idx = 0;
                    }
                    oldPoint = me.#Points[idx];
                }
                offset = me.getMousePosition(evt);
                let offsetP = Point.newPoint(offset);
                mouseOffset = offsetP.subtract(oldPoint);
            }
        }

        function drag(evt: any) {
            if (!me.isDragging)
                return;

            if (selectedElement) {
                evt.preventDefault();
                var coord = me.getMousePosition(evt);

                let newP = new Point(coord.x, coord.y);
                switch (selectedElement.nodeName) {
                    case "text":
                        let label = me.svgLabels[tag];
                        let np = newP.subtractVector(mouseOffset);
                        label.move(np.x, np.y);
                        break;
                    case "circle":
                        let MovePoint: number = +idx;
                        let oldP = me.#Points[MovePoint];
                        if (MovePoint == 0) {
                            me.#Points[MovePoint] = newP;
                        } else {
                            let moveDistance: Vector = Point.subtractPoint(newP, oldP);
                            if (moveDistance.length >= 1) {
                                for (let i = MovePoint; i < me.#Points.length; i++) {
                                    let np = me.#Points[i].addVector(moveDistance);
                                    me.#Points[i] = np;
                                }
                            }
                        }
                        me.drawTempMovingObject(idx);
                        me.updateDrawingObjects();

                        let activeInput = document.activeElement as HTMLInputElement;
                        if (activeInput.tagName.toLowerCase() === 'input') {
                            activeInput.blur();
                        }
                        MovePoint = MovePoint === 0 ? 0 : MovePoint - 1;
                        let inputTag = 'Len' + (MovePoint);
                        let input = document.getElementById(inputTag) as HTMLInputElement;
                        input.classList.add('nctd-highlightInput');
                        input.scrollIntoView();
                        break;
                    default:
                        break;
                }
            }
        }

        function endDrag(evt: any) {
            if (selectedElement !== undefined) {
                if (me.isDragging) { // Need to check if we are still dragging in case user pressed escape to quit dragging.
                    if (selectedElement.nodeName === "text") {
                        let label = me.svgLabels[tag];
                        let newLabelPoint = new Point(label.x(), label.y());

                        let moveDistance = Point.subtractPoint(newLabelPoint, oldPoint);
                        let oldLabelOffset = new Vector(0, 0);
                        if (tag in me.LabelOffsets) {
                            oldLabelOffset = me.LabelOffsets[tag];
                        }
                        let newLabelOffset = Vector.addVector(moveDistance, oldLabelOffset);
                        me.LabelOffsets[tag] = newLabelOffset;
                    }
                    if (selectedElement) {
                        me.addUndoPoint();
                    }
                }
            }
            selectedElement = false;
            me.#tempMovingLines.forEach((shape) => shape.remove());
            me.#tempMovingLines.length = 0; //clear array
            tag = "";
            idx = 0;
            // dragging = false; // Need to set this to false on svgMouseUp
            me.panZoomInstance.enablePan();
        }
    }

    #tempMovingLines = new Array<Line>();
    drawTempMovingObject(MovePoint: number) {
        this.#tempMovingLines.forEach((shape) => shape.remove());
        this.#tempMovingLines.length = 0; //clear array

        if (this.#settings.Snap && this.#Points.length > 1) {
            let priorPoints = new Array<Point>();

            if (MovePoint == 0) {
                for (let i = 1; i < this.#Points.length; i++) {
                    priorPoints.push(this.#Points[i].clone());
                }
            }
            else {
                for (let i = 0; i < MovePoint; i++) {
                    priorPoints.push(this.#Points[i].clone());
                }
            }

            let closestX: number = priorPoints.reduce((x, y) =>
                Math.abs(x.x - this.#MousePoint.x) < Math.abs(y.x - this.#MousePoint.x)
                    ? x
                    : y
            ).x;
            let closestY: number = priorPoints.reduce((x, y) =>
                Math.abs(x.y - this.#MousePoint.y) < Math.abs(y.y - this.#MousePoint.y)
                    ? x
                    : y
            ).y;

            if (Math.abs(closestX - this.#MousePoint.x) <= this.#settings.SnapPrecision / this.ZoomScale) {
                //snap to closest horizontal point
                this.#MousePoint.x = closestX;
                this.#tempPoint.x = closestX;
                let line = this.svgGroup
                    .line(this.#tempPoint.x, -10000, this.#tempPoint.x, 10000)
                    .stroke({ color: "#2b7535", width: this.LineWidth / 3 });
                line.back();
                this.#tempMovingLines.push(line);
            }
            if (Math.abs(closestY - this.#MousePoint.y) <= this.#settings.SnapPrecision / this.ZoomScale) {
                //snap to closest horizontal point
                this.#MousePoint.y = closestY;
                this.#tempPoint.y = closestY;
                let line = this.svgGroup
                    .line(-10000, this.#tempPoint.y, 10000, this.#tempPoint.y)
                    .stroke({ color: "#2b7535", width: this.LineWidth / 3 });
                line.back();
                this.#tempMovingLines.push(line);
            }
            let snapDistance: Vector = this.#tempPoint.subtract(
                this.#Points[MovePoint]
            );
            if (snapDistance.length != 0) {
                if (MovePoint == 0) {
                    this.#Points[0] = this.#Points[0].addVector(snapDistance);
                }
                else {
                    for (let i = MovePoint; i < this.#Points.length; i++) {
                        this.#Points[i] = this.#Points[i].addVector(snapDistance);
                    }
                }
            }
        }
    }



    #RedoStack = new Array<UndoPoint>();
    #UndoStack = new Array<UndoPoint>();

    addUndoPoint() {
        this.#RedoStack.length = 0;
        let undoPoint = new UndoPoint(this.#Segments, this.LabelOffsets, this.#Points, this.#trimOptionsManager.ReversePaintedSide); // this.#ReversePaintIndicator);
        if (this.isDrawing && undoPoint.Segments.length > 0) {
            undoPoint.Segments.splice(-1, 1);
        }
        this.#UndoStack.push(undoPoint);
    }

    undo() {
        if (this.#UndoStack.length > 1) {
            let undoPoint = this.#UndoStack.pop();
            if (undoPoint !== undefined) {
                this.#RedoStack.push(undoPoint);
            }

            if (this.#UndoStack.length > 0) {
                this.restoreUndoPoint(this.#UndoStack[this.#UndoStack.length - 1]);
            }
        }
        this.updateDrawingObjects();
    }

    redo() {
        if (this.#RedoStack.length > 0) {
            let undoPoint = this.#RedoStack.pop();
            if (undoPoint !== undefined) {
                this.#UndoStack.push(undoPoint);
                this.restoreUndoPoint(undoPoint);
            }
        }
        this.updateDrawingObjects();
    }

    restoreUndoPoint(undoPoint: UndoPoint) {
        if (undoPoint != null) {
            this.#Segments = undoPoint.Segments.slice(0);
            this.LabelOffsets = undoPoint.LabelOffsets;
            this.#trimOptionsManager.ReversePaintedSide = undoPoint.ReversePaintIndicator;

            if (this.#Segments.length > 0) {
                // SegmentUpdated(Segments[0]);
            }
            else {
                // this.#Points.length = 0;
                // if (undoPoint.Points.Count > 0){
                //     this.#Points = undoPoint.Points[0] };
                //     }

            }
            this.loadSegments();
        }
    }

    startDrawing() {
        if (this.ReadOnly) return;
        this.isDrawing = true;
        let startStopDrawingButton = document.getElementById("ncStartStopDrawing") as HTMLButtonElement;
        startStopDrawingButton.innerText = "Stop Drawing";
        this.updateDrawingObjects();
    }
    stopDrawing() {
        this.isDrawing = false;
        let startStopDrawingButton = document.getElementById("ncStartStopDrawing") as HTMLButtonElement;
        startStopDrawingButton.innerText = "Start Drawing";
        this.updateDrawingObjects();
    }

    initButtons() {
        let me = this;;
        let startStopDrawingButton = document.getElementById("ncStartStopDrawing") as HTMLButtonElement;
        startStopDrawingButton.innerText = me.isDrawing ? "Stop Drawing" : "Start Drawing";
        startStopDrawingButton?.addEventListener("click", function (e) {
            me.isDrawing = !me.isDrawing;
            startStopDrawingButton.innerText = me.isDrawing ? "Stop Drawing" : "Start Drawing";
            me.updateDrawingObjects();
        });

        let undoButton = document.getElementById("ncUndo") as HTMLButtonElement;
        undoButton?.addEventListener("click", function (e) {
            me.undo();
        });
        let redoButton = document.getElementById("ncRedo") as HTMLButtonElement;
        redoButton?.addEventListener("click", function (e) {
            me.redo();
        });
        let zoomToFitButton = document.getElementById("ncZoomToFit") as HTMLButtonElement;
        zoomToFitButton?.addEventListener("click", function (e) {
            me.zoomToFit();
        });
    }

    static GetArcMidPoint(arc: Path): Point {
        let length = arc.length() / 2;
        let midPoint = arc.pointAt(length);
        return Point.newPoint(midPoint);
    }
}
class LinePoint {
    constructor(public Start: Point, public End: Point) {
        this.Start = Start;
        this.End = End;
    }

    midwayPoint(): Point {
        let x = (this.Start.x + this.End.x) / 2;
        let y = (this.Start.y + this.End.y) / 2;
        return new Point(x, y);
    }
}
